import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { BlueElement, classMap, ifDefined, register as blueRegister, nothing } from '@onviobr/element';
import { getHigherZIndex } from '@onviobr/ui-elements';
import { EventType } from '..';
import { firstFocusableKeyHandler, lastFocusableKeyHandler } from '../accessibility-utility';
import { defaultOptions } from '../dms-viewer-interface';
import { defaultColor } from '../palette';
import { buttonStyles } from './common-styles.css';
import { Fonts, FontSizes, TextStyles, WatermarkLocation, FontColorIconSvg, FontStyleBoldIconSvg, FontStyleItalicIconSvg, FontStyleUnderlineIconSvg } from './watermark-modal-interface';
import { styles } from './watermark-modal.css';
var WatermarkModal = /*#__PURE__*/function (_BlueElement) {
  function WatermarkModal() {
    var _this;
    _classCallCheck(this, WatermarkModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WatermarkModal, [].concat(args));
    _this.strings = defaultOptions.strings;
    _this.watermarkSettings = void 0;
    _this.watermarkLocation = WatermarkLocation.center;
    _this.isColorPaletteVisible = false;
    _this.initialWatermarkOptions = _this.getDefaultWatermarkOptions();
    _this.focusCloseBtn = false;
    return _this;
  }
  _inherits(WatermarkModal, _BlueElement);
  return _createClass(WatermarkModal, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      this.updateWatermark();
      if (this.watermarkSettings) {
        this.initialWatermarkOptions = {};
        for (var _i = 0, _Object$values = Object.values(WatermarkLocation); _i < _Object$values.length; _i++) {
          var watermarkLocation = _Object$values[_i];
          this.initialWatermarkOptions[watermarkLocation] = _objectSpread(_objectSpread({}, this.watermarkSettings[watermarkLocation]), {}, {
            fontStyles: _toConsumableArray(this.watermarkSettings[watermarkLocation].fontStyles)
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$watermarkSettin,
        _this2 = this,
        _this$strings,
        _this$strings2,
        _this$strings3,
        _this$strings4,
        _this$strings5,
        _this$strings6,
        _options$opacity,
        _this$strings7,
        _this$strings8,
        _this$strings9,
        _this$strings10;
      this.watermarkSettings = (_this$watermarkSettin = this.watermarkSettings) !== null && _this$watermarkSettin !== void 0 ? _this$watermarkSettin : this.getDefaultWatermarkOptions();
      var locations = Object.keys(WatermarkLocation).map(function (item) {
        var locationKey = item;
        return _this2.html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t<option\n\t\t\t\t\tselected=", "\n\t\t\t\t\tvalue=\"", "\">\n\t\t\t\t\t", "\n\t\t\t\t</option>"])), ifDefined(WatermarkLocation[locationKey] === _this2.watermarkLocation ? 'selected' : undefined), WatermarkLocation[locationKey], _this2.strings[locationKey]);
      });
      var options = _objectSpread({}, this.watermarkSettings[this.watermarkLocation]);
      var sizes = FontSizes.map(function (item) {
        return _this2.html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<option selected=", "\n\t\t\t\tvalue=\"", "\">", "</option>"])), ifDefined(item === options.fontSize ? 'selected' : undefined), item, item);
      });
      var fonts = Fonts.map(function (item) {
        return _this2.html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<option selected=", "\n\t\t\t\tvalue=\"", "\">", "</option>"])), ifDefined(item === options.fontFamily ? 'selected' : undefined), item, item);
      });
      var fontStyles = options.fontStyles;
      var defaultClasses = {
        'style-button': true,
        selected: false
      };
      var boldStyleClassMap = classMap(_objectSpread(_objectSpread({}, defaultClasses), {}, {
        selected: fontStyles.includes(TextStyles.bold)
      }));
      var italicStyleClassMap = classMap(_objectSpread(_objectSpread({}, defaultClasses), {}, {
        selected: fontStyles.includes(TextStyles.italic)
      }));
      var underlineStyleClassMap = classMap(_objectSpread(_objectSpread({}, defaultClasses), {}, {
        selected: fontStyles.includes(TextStyles.underline)
      }));
      return this.html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t<bm-modal closeButtonQeId=\"watermark-modal-close-button\" @closeKeyDown=", " style=\"z-index:", ";\"\n\t\t\t\tmodalTitle=\"", "\" .focusCloseBtn=", " .focusModal=\"", "\"\n\t\t\t\tmodalSize=\"medium\" .backdropClose=", " closeButtonQeId=\"watermark-modal-close-button\" @close=", ">\n\t\t\t\t<div class=\"row\" tabindex=\"-1\">\n\t\t\t\t\t<div class=\"column\">\n\t\t\t\t\t\t<label class=\"placement-container\">\n\t\t\t\t\t\t\t", " <br>\n\t\t\t\t\t\t\t<select id=\"locations\" data-qe-id=\"watermark-modal-placement-select\" name=\"locations\"\n\t\t\t\t\t\t\t\t@change=", ">\n\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<label class=\"text-container\">\n\t\t\t\t\t\t\t", " <br>\n\t\t\t\t\t\t\t<input id=\"text\" data-qe-id=\"watermark-modal-text-input\" type=\"text\" .value=", "\n\t\t\t\t\t\t\t\t@input=", ">\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t", " <br>\n\t\t\t\t\t\t\t<select id=\"fonts\" data-qe-id=\"watermark-modal-fonts-select\" name=\"fonts\" @change=", ">\n\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t", " <br>\n\t\t\t\t\t\t\t<select id=\"sizes\" data-qe-id=\"watermark-modal-size-select\" name=\"sizes\" @change=", ">\n\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<label class=\"opacity-container\">\n\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t", " <br>\n\t\t\t\t\t\t\t\t<input id=\"opacity\" data-qe-id=\"watermark-modal-opacity-slider\" type=\"range\" min=\"0\" max=\"100\"\n\t\t\t\t\t\t\t\t.value=", " @input=", ">\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<span class=\"opacity-label\">", "%</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"font-styles-container\">\n\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t<div class=\"styles-container\">\n\t\t\t\t\t\t\t\t<div class=\"style-item\">\n\t\t\t\t\t\t\t\t\t<button id=\"color-icon\" data-qe-id=\"watermark-modal-color-input\" class=\"style-button\"\n\t\t\t\t\t\t\t\t\t\t@click=", ">\n\t\t\t\t\t\t\t\t\t\t<div class=\"icon\" style=\"fill:", "; stroke:", "\">\n\t\t\t\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"style-item\">\n\t\t\t\t\t\t\t\t\t<button id=\"bold-icon\" class=", " id=\"bold-text\" data-qe-id=\"watermark-modal-bold-style-button\"\n\t\t\t\t\t\t\t\t\t\t@click=", ">\n\t\t\t\t\t\t\t\t\t\t<div class=\"icon\">\n\t\t\t\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"style-item\">\n\t\t\t\t\t\t\t\t\t<button id=\"italic-icon\" class=", " id=\"italic-text\" data-qe-id=\"watermark-modal-italic-style-button\"\n\t\t\t\t\t\t\t\t\t\t@click=", ">\n\t\t\t\t\t\t\t\t\t\t<div class=\"icon\">\n\t\t\t\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"style-item\">\n\t\t\t\t\t\t\t\t\t<button id=\"underline-icon\" class=", " id=\"underlined-text\" data-qe-id=\"watermark-modal-underline-style-button\"\n\t\t\t\t\t\t\t\t\t\t@click=", ">\n\t\t\t\t\t\t\t\t\t\t<div class=\"icon\">\n\t\t\t\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t", "\n\t\t\t\t\t\t<div class=\"restore-default-settings-container\">\n\t\t\t\t\t\t\t<button class=\"btn btn-outline-primary\" data-qe-id=\"watermark-modal-restore-default-settings-button\"\n\t\t\t\t\t\t\t\t@click=", ">\n\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"column\">\n\t\t\t\t\t\t<div id=\"canvas-container\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"footer\">\n\t\t\t\t\t<button class=\"btn btn-primary\" data-qe-id=\"watermark-modal-add-button\"\n\t\t\t\t\t\t@click=", ">", "</button>\n\t\t\t\t\t<button id=\"watermark-modal-cancel-btn\" class=\"btn btn-outline-primary cancel-button\" data-qe-id=\"watermark-modal-cancel-button\"\n\t\t\t\t\t\t@click=", " @keydown=", "\n\t\t\t\t\t\t@keyup=", ">", "</button>\n\t\t\t\t</div>\n\t\t\t</bm-modal>\n\t\t"])), function () {
        return firstFocusableKeyHandler(_this2.renderRoot, '#watermark-modal-cancel-btn');
      }, getHigherZIndex() + 1, (_this$strings = this.strings) === null || _this$strings === void 0 ? void 0 : _this$strings.addWatermark, this.focusCloseBtn, true, false, this.cancelHandler, (_this$strings2 = this.strings) === null || _this$strings2 === void 0 ? void 0 : _this$strings2.placement, this.changeWatermarkLocationHandler, locations, (_this$strings3 = this.strings) === null || _this$strings3 === void 0 ? void 0 : _this$strings3.text, options.text, this.changeWatermarkOptionsHandler, (_this$strings4 = this.strings) === null || _this$strings4 === void 0 ? void 0 : _this$strings4.font, this.changeWatermarkOptionsHandler, fonts, (_this$strings5 = this.strings) === null || _this$strings5 === void 0 ? void 0 : _this$strings5.size, this.changeWatermarkOptionsHandler, sizes, (_this$strings6 = this.strings) === null || _this$strings6 === void 0 ? void 0 : _this$strings6.opacity, options.opacity, this.changeWatermarkOptionsHandler, (_options$opacity = options.opacity) !== null && _options$opacity !== void 0 ? _options$opacity : 0, (_this$strings7 = this.strings) === null || _this$strings7 === void 0 ? void 0 : _this$strings7.fontStyle, function () {
        return _this2.setColorPaletteVisibility(!_this2.isColorPaletteVisible);
      }, options.color, options.color, FontColorIconSvg, boldStyleClassMap, function () {
        return _this2.styleButtonClickHandler(TextStyles.bold);
      }, FontStyleBoldIconSvg, italicStyleClassMap, function () {
        return _this2.styleButtonClickHandler(TextStyles.italic);
      }, FontStyleItalicIconSvg, underlineStyleClassMap, function () {
        return _this2.styleButtonClickHandler(TextStyles.underline);
      }, FontStyleUnderlineIconSvg, this.isColorPaletteVisible ? this.html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t<div class=\"style-popup\" id=\"style-popup\"\n\t\t\t\t\t\t\t\t\t@click=", ">\n\t\t\t\t\t\t\t\t\t<color-palette\n\t\t\t\t\t\t\t\t\t\t@colorChanged=", "\n\t\t\t\t\t\t\t\t\t\t.currentColor=", ">\n\t\t\t\t\t\t\t\t\t</color-palette>\n\t\t\t\t\t\t\t\t</div>"])), function () {
        return _this2.setColorPaletteVisibility(false);
      }, function (e) {
        return _this2.setActiveColor(e);
      }, options.color) : nothing, this.resetAllOptionsHandler, (_this$strings8 = this.strings) === null || _this$strings8 === void 0 ? void 0 : _this$strings8.restoreDefaultSettings, this.closeHandler, (_this$strings9 = this.strings) === null || _this$strings9 === void 0 ? void 0 : _this$strings9.add, this.cancelHandler, function (e) {
        return lastFocusableKeyHandler(e, function () {
          _this2.focusCloseBtn = true;
        });
      }, function (e) {
        return lastFocusableKeyHandler(e, function () {
          _this2.focusCloseBtn = false;
        });
      }, (_this$strings10 = this.strings) === null || _this$strings10 === void 0 ? void 0 : _this$strings10.cancel);
    }
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      var modalContainer = document.createElement('div');
      modalContainer.style.setProperty('z-index', "".concat(getHigherZIndex() + 1));
      document.body.appendChild(modalContainer);
      return modalContainer.attachShadow({
        mode: 'open'
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _superPropGet(WatermarkModal, "disconnectedCallback", this, 3)([]);
      var renderRoot = this.renderRoot;
      renderRoot.host.parentElement.removeChild(renderRoot.host);
    }
  }, {
    key: "closeHandler",
    value: function closeHandler() {
      this.dispatchEvent(new CustomEvent(EventType.WatermarkModalClosed));
    }
  }, {
    key: "cancelHandler",
    value: function cancelHandler() {
      this.watermarkSettings = this.initialWatermarkOptions;
      this.updateWatermark();
      this.closeHandler();
    }
  }, {
    key: "resetAllOptionsHandler",
    value: function resetAllOptionsHandler() {
      this.watermarkSettings = this.getDefaultWatermarkOptions();
      this.watermarkLocation = WatermarkLocation.center;
      this.updateWatermark();
    }
  }, {
    key: "changeWatermarkOptionsHandler",
    value: function changeWatermarkOptionsHandler() {
      this.watermarkSettings[this.watermarkLocation] = _objectSpread(_objectSpread({}, this.watermarkSettings[this.watermarkLocation]), {}, {
        text: this.renderRoot.querySelector('#text').value,
        fontSize: Number(this.renderRoot.querySelector('#sizes').value),
        fontFamily: this.renderRoot.querySelector('#fonts').value,
        opacity: Number(this.renderRoot.querySelector('#opacity').value)
      });
      this.fillRange();
      this.updateWatermark();
    }
  }, {
    key: "changeWatermarkLocationHandler",
    value: function changeWatermarkLocationHandler() {
      this.watermarkLocation = this.renderRoot.querySelector('#locations').value;
      this.fillRange();
    }
  }, {
    key: "styleButtonClickHandler",
    value: function styleButtonClickHandler(textStyle) {
      var fontStyles = this.watermarkSettings[this.watermarkLocation].fontStyles;
      if (fontStyles.includes(textStyle)) {
        this.watermarkSettings[this.watermarkLocation].fontStyles = fontStyles.filter(function (item) {
          return item !== textStyle;
        });
      } else {
        fontStyles.push(textStyle);
      }
      this.updateWatermark();
    }
  }, {
    key: "updateWatermark",
    value: function updateWatermark() {
      var canvasContainer = this.renderRoot.querySelector('#canvas-container');
      this.dispatchEvent(new CustomEvent(EventType.WatermarkChanged, {
        detail: {
          options: this.watermarkSettings,
          canvasContainer: canvasContainer
        }
      }));
    }
  }, {
    key: "setColorPaletteVisibility",
    value: function setColorPaletteVisibility(visible) {
      this.isColorPaletteVisible = visible;
    }
  }, {
    key: "setActiveColor",
    value: function setActiveColor(e) {
      this.watermarkSettings[this.watermarkLocation].color = e.detail.color;
      this.changeWatermarkOptionsHandler();
    }
  }, {
    key: "getDefaultWatermarkOptions",
    value: function getDefaultWatermarkOptions() {
      var options = {};
      Object.values(WatermarkLocation).forEach(function (item) {
        options[item] = {
          text: '',
          fontSize: 48,
          fontFamily: Fonts[0],
          color: defaultColor,
          opacity: 100,
          fontStyles: []
        };
      });
      return options;
    }
  }, {
    key: "fillRange",
    value: function fillRange() {
      var opacityRange = this.renderRoot.querySelector('#opacity');
      if (this.watermarkSettings && opacityRange) {
        var opacity = _objectSpread({}, this.watermarkSettings[this.watermarkLocation]).opacity.toString();
        opacityRange.style.background = "linear-gradient(to right, #212121 0%, #212121 ".concat(opacity, "%, #939393 ").concat(opacity, "%, #939393 100%)");
      }
    }
  }], [{
    key: "is",
    get: function get() {
      return 'watermark-modal';
    }
  }, {
    key: "styles",
    get: function get() {
      return [styles, buttonStyles];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        strings: {
          type: Object
        },
        watermarkSettings: {
          type: Object
        },
        watermarkLocation: {
          type: String,
          attribute: false
        },
        isColorPaletteVisible: {
          type: Boolean,
          attribute: false
        },
        focusCloseBtn: {
          type: Boolean,
          attribute: false
        }
      };
    }
  }]);
}(BlueElement);
export { WatermarkModal as default };
export var registerWatermarkModal = function registerWatermarkModal() {
  return blueRegister(WatermarkModal);
};
